<template>
  <div
    class="text-right remaining-length font-small text-dark-gray"
  >
    <span>残り{{ remainingLength }}文字</span>
  </div>
</template>

<script>
export default {
  props: {
    remainingLength: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped>
.remaining-length {
  margin-top: 3px;
}
</style>
